// Status colours shared across all KPI tiles - identical to the legacy
// KPIGauge palette so historical dashboards read the same.
const tileColors = {
  success: {
    main: '#059669',
    background:
      'linear-gradient(135deg, rgba(5, 150, 105, 0.14), rgba(5, 150, 105, 0.03))',
  },
  warning: {
    main: '#d97706',
    background:
      'linear-gradient(135deg, rgba(245, 158, 11, 0.12), rgba(245, 158, 11, 0.02))',
  },
  error: {
    main: '#e11d48',
    background:
      'linear-gradient(135deg, rgba(244, 63, 94, 0.12), rgba(244, 63, 94, 0.02))',
  },
  neutral: {
    main: '#2563eb',
    background:
      'linear-gradient(135deg, rgba(59, 130, 246, 0.12), rgba(59, 130, 246, 0.02))',
  },
}

export const statusColor = (status) => tileColors[status] ?? tileColors.neutral

export const chartBlue = '#268EBB'

// Breakdown labels can arrive as raw enum keys ("AdverseIncident")
export const humaniseLabel = (label) =>
  String(label ?? '').replace(/([a-z])([A-Z])/g, '$1 $2')

const ragOrder = ['red', 'amber', 'green']
const ragColors = {
  red: tileColors.error.main,
  amber: tileColors.warning.main,
  green: tileColors.success.main,
}

// Shared by the on-screen tile and the PDF chart: readable labels, and RAG
// breakdowns drawn in severity order with their own colours.
export const breakdownChartData = (items = []) => {
  const isRag =
    items.length > 0 && items.every((item) => ragOrder.includes(String(item.label).toLowerCase()))
  const ordered = isRag
    ? [...items].sort(
        (a, b) =>
          ragOrder.indexOf(String(a.label).toLowerCase()) -
          ragOrder.indexOf(String(b.label).toLowerCase()),
      )
    : items
  return {
    labels: ordered.map((item) => humaniseLabel(item.label)),
    values: ordered.map((item) => item.value),
    colors: isRag ? ordered.map((item) => ragColors[String(item.label).toLowerCase()]) : chartBlue,
  }
}

export default tileColors
